module.exports = __webpack_public_path__ + "media/customizations/tradition/back-e6213675c208f1a16f0f719917e2978d.jpg";